import { createReducer } from '../../../redux-util/general-helpers';
import {
  clearSingleFilter,
  setFilter,
  applyFilters,
  clearFilters,
} from './actions';

const activeHandlers = {
  [setFilter().type]: (state, action) => {
    return {
      ...state,
      [action.taxonomy]: {
        ...state[action.taxonomy],
        [action.name]: action.value,
      },
    };
  },
  [clearSingleFilter().type]: (state, action) => {
    return {
      ...state,
      [action.name]: {},
    };
  },
};

const updateActive = createReducer({}, activeHandlers);

const initial = {};
const initialState = { active: initial, applied: initial };

export default function taxonomyFiltersReducer(state = initialState, action) {
  if (action.type === applyFilters().type) {
    return {
      ...state,
      applied: state.active,
    };
  } else if (action.type === clearFilters().type) {
    return initialState;
  }
  return {
    ...state,
    active: updateActive(state.active, action),
  };
}
